import {
    COLLAPSE_OPEN_BET_ACCORDION,
    COLLAPSE_PLACED_BET_ACCORDION,
    COLLAPSE_SETTLED_BET_ACCORDION
} from '../constants/actionTypes';

export function collapseOpenBetAccordion(gameCategory) {
    return {type: COLLAPSE_OPEN_BET_ACCORDION, 'gameCategory': gameCategory};
}

export function collapsePlacedBetAccordion(gameCategory) {
    return {type: COLLAPSE_PLACED_BET_ACCORDION, gameCategory: gameCategory};
}

export function collapseSettledBetAccordion(gameCategory) {
    return {type: COLLAPSE_SETTLED_BET_ACCORDION, gameCategory: gameCategory};
}



// WEBPACK FOOTER //
// ./src/actions/betSlipActions.js